import React, { createContext, useRef, useState } from 'react'
import GlobalLoading from './GlobalLoading'
import LoadingBar from 'react-top-loading-bar'
export const GlobalLoadingContext = createContext(null)

type GlobalLoadingProviderProps = {
    color?: string
}

const GlobalLoadingProvider: React.FC<GlobalLoadingProviderProps> = ({ color = '#33dcbd', children }) => {
    const ref = useRef(null)
    const handleStart = () => {
        ref.current.continuousStart()
    }

    const handleComplete = () => {
        ref.current.complete()
    }

    return (
        <GlobalLoadingContext.Provider
            value={{
                start: handleStart,
                complete: handleComplete,
            }}
        >
            <LoadingBar color={color} ref={ref} />
            {children}
        </GlobalLoadingContext.Provider>
    )
}

export default GlobalLoadingProvider
